var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spinning-loader", style: _vm.rootStyles }, [
    _c(
      "svg",
      {
        staticClass: "spinning-loader--svg",
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          version: "1.1",
          preserveAspectRatio: "none",
          tabindex: "-1",
          viewBox: _vm.svgViewBox
        }
      },
      [
        _c("path", {
          ref: "svgPath",
          staticClass: "spinning-loader--svg-path",
          style: _vm.svgPathStyles,
          attrs: { d: _vm.svgPathContent }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11129848", { render: render, staticRenderFns: staticRenderFns })
  }
}